/**
 * The Base API Resource
 * This is extensible to cover all other API resources
 */

export class Resource {
  id: string; // by default, each resource will have an ID
}
